/**
 * AI Hub Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.3.2
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ClipDetailsResponse } from './clipDetailsResponse';
import { ManagementMediumResponse } from './managementMediumResponse';
import { ManagementTagResponse } from './managementTagResponse';
import { SentimentResponse } from './sentimentResponse';

export interface ManagementClipResponse { 
    id: string;
    url?: string;
    mediaUrl?: string;
    publicationDate?: Date;
    area?: string;
    pageNumber?: string;
    main?: boolean;
    important?: boolean;
    source?: ManagementClipResponse.SourceEnum;
    sif?: number;
    medium?: ManagementMediumResponse;
    type?: ManagementClipResponse.TypeEnum;
    hasVideo?: boolean;
    groupId?: string;
    externalId?: string;
    screenshotUrl?: string;
    visibilityIndex?: number;
    details?: Array<ClipDetailsResponse>;
    tags?: Array<ManagementTagResponse>;
    transcribed?: boolean;
    createdAt?: Date;
    relatedCount?: number;
    sentiment?: SentimentResponse;
}
export namespace ManagementClipResponse {
    export type SourceEnum = 'GRID' | 'FAXAL' | 'INOREADER' | 'DEFAULT' | 'COPY' | 'NEW_GROUP' | 'CLIPS' | 'MANUAL' | 'IMPORT';
    export const SourceEnum = {
        GRID: 'GRID' as SourceEnum,
        FAXAL: 'FAXAL' as SourceEnum,
        INOREADER: 'INOREADER' as SourceEnum,
        DEFAULT: 'DEFAULT' as SourceEnum,
        COPY: 'COPY' as SourceEnum,
        NEWGROUP: 'NEW_GROUP' as SourceEnum,
        CLIPS: 'CLIPS' as SourceEnum,
        MANUAL: 'MANUAL' as SourceEnum,
        IMPORT: 'IMPORT' as SourceEnum
    };
    export type TypeEnum = 'NEUTRAL' | 'PROMOTIONAL' | 'ABUSIVE';
    export const TypeEnum = {
        NEUTRAL: 'NEUTRAL' as TypeEnum,
        PROMOTIONAL: 'PROMOTIONAL' as TypeEnum,
        ABUSIVE: 'ABUSIVE' as TypeEnum
    };
}